import { WhitelabelConfig } from './types';
import { WhitelabelId } from './WhitelabelId';
import AgodaWhitelabelConfig from './configs/agoda';
import JapanicanWhitelabelConfig from './configs/japanican';
import PricelineWhitelabelConfig from './configs/priceline';
import RurubuWhitelabelConfig from './configs/rurubu';
import CitiWhitelabelConfig from '@whitelabel/configs/citi';
import RocketmilesWhitelabelConfig from '@whitelabel/configs/rocketmiles';
import WikibuyWhitelabelConfig from './configs/wikibuy';
import HotelstormWhitelabelConfig from './configs/hotelstorm';
import JtbWhitelabelConfig from './configs/jtb';

export class WhitelabelFactory {
    public static getConfig(id: WhitelabelId): WhitelabelConfig {
        switch (id) {
            case WhitelabelId.CITIUS:
            case WhitelabelId.CITIUSUAT1:
            case WhitelabelId.CITIUSUAT2:
            case WhitelabelId.CITIUSUAT3:
                return CitiWhitelabelConfig;
            case WhitelabelId.JTB:
            case WhitelabelId.JTBUAT:
                return JtbWhitelabelConfig;
            case WhitelabelId.JAPANICAN:
            case WhitelabelId.JAPANICANUAT:
                return JapanicanWhitelabelConfig;
            case WhitelabelId.RURUBUUAT:
            case WhitelabelId.RURUBU:
                return RurubuWhitelabelConfig;
            case WhitelabelId.PRICELINE:
                return PricelineWhitelabelConfig;
            case WhitelabelId.ROCKETMILES:
                return RocketmilesWhitelabelConfig;
            case WhitelabelId.WIKIBUY:
                return WikibuyWhitelabelConfig;
            case WhitelabelId.HOTELSTORM:
                return HotelstormWhitelabelConfig;
            case WhitelabelId.AGODA:
            case WhitelabelId.AGODAUAT:
            default:
                return AgodaWhitelabelConfig;
        }
    }
}
